module.exports = __webpack_public_path__ + "../resources/images/drophint_2x_bw-ebc5f761abd94baecea40bcbf6872e02.png";